import api from "@beeldit/core/helpers/api";

async function update(endpoint: string, id: number, data: any) {
  return api.put(`/${endpoint}/${id}`, data);
}

export default update;
